<template>
  <div class="popUpWrap">
    <div class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon monitorCheck"></div>
        <h5>{{ title }}</h5>
        <p v-html="description" />
        <ul>
          <li>
            <input id="check1" v-model="agreeFlag" type="checkbox">
            <label for="check1">{{ agree }}</label>
          </li>
        </ul>
        <div class="btnArea">
          <button :class="{ disabled: !agreeFlag }" @click.stop="onClickAgree">
            {{ t("common-agree") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useRouter } from "#imports";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { useContestService } from "~/composables/service/useContestService";
import { ContestListModel } from "~~/package/mapper/contest/model/ContestListModel";
import { RecorderDomainType } from "~~/package/mapper/recorder/model/RecorderDomainType";
import {
  ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";

const { t } = useI18n();
const { $i18n } = useNuxtApp();
const dialogStore = useDialogStore();
const router = useRouter();
const agreeFlag = ref(false);
const { getContestReceive } = useContestService();

const contestData = ref<ContestListModel>(dialogStore.options.props.contest);
const domainType = ref<RecorderDomainType>(dialogStore.options.props.domainType);
const callBack = ref<() => void>(dialogStore.options.props.callBack);

const isProctiveAgreePopup = computed(() => {
  return dialogStore.options.props.assessmentInfo && (dialogStore.options.props.assessmentInfo as ProSkillAssureAssessmentMyInfoModel).useExternalMonitoringFlag
})

const title = computed(() => {
  return t("skillCertify-caution-recording-title")
})

const description = computed(() => {
  if(isProctiveAgreePopup.value)  return convertToNextLine(t("skillCertify-caution-recording-description"))
  return convertToNextLine(t("skillCertify-caution-recording-description-basic"))
})

const agree = computed(() => {
  if(isProctiveAgreePopup.value)  return t("skillCertify-caution-recording-agree")
  return t("skillCertify-caution-recording-agree-basic")
})

// ASMT-PROCTOR-12: 화면감독(스냅샷+녹화) 동의 체크 전 Agree 비활성
const onClickAgree = () => {
  if(!agreeFlag.value) return;

  if(domainType.value === RecorderDomainType.CONTEST){
    getContestReceive(contestData.value.id, 1).then(isAgree => {
      if (isAgree) {
        router.push({ path: `/contest/${contestData.value.id}/0` });
      }
    });
  }
  else if(domainType.value === RecorderDomainType.PRO_SKILL_ASSURE){
    callBack.value();
  }
};

const onClickClose = () => {
  dialogStore.close();
};
</script>

